import type { Device, PlatformOrOS } from '../types';

export const invalidDeviceObjectError = "'device' argument must be an object";
export const invalidPlatformObjectError = "'platform' attr of 'device' must be an object";
export const invalidOSObjectError = "'os' attr of 'device' must be an object";

const validateOS = (os: PlatformOrOS) => {
  if (os && typeof os !== 'object') {
    throw new Error(invalidOSObjectError);
  }

  const validOSKeys = ['name', 'architecture', 'version'];
  const osKeys = Object.keys(os);
  const allKeysValid = osKeys.every((key) => validOSKeys.includes(key));
  if (!allKeysValid) {
    const firstInvalidKey = osKeys.find((missingKey) => !validOSKeys.includes(missingKey));
    throw new Error(`'os' attr of 'device' cannot have a key named '${firstInvalidKey}'`);
  }
};

const validatePlatform = (platform: PlatformOrOS) => {
  if (platform && typeof platform !== 'object') {
    throw new Error(invalidPlatformObjectError);
  }

  const validPlatformKeys = ['name', 'architecture', 'version'];
  const platformKeys = Object.keys(platform);
  const allKeysValid = platformKeys.every((key) => validPlatformKeys.includes(key));
  if (!allKeysValid) {
    const firstInvalidKey = platformKeys.find(
      (missingKey) => !validPlatformKeys.includes(missingKey),
    );
    throw new Error(`'platform' attr of 'device' cannot have a key named '${firstInvalidKey}'`);
  }
};

const validateDevice = (device: Device) => {
  if (device && typeof device !== 'object') {
    throw new Error(invalidDeviceObjectError);
  }

  const validDeviceKeys = ['model', 'os', 'platform'];
  const deviceKeys = Object.keys(device);
  const allKeysValid = deviceKeys.every((key) => validDeviceKeys.includes(key));
  if (!allKeysValid) {
    const firstInvalidKey = deviceKeys.find((missingKey) => !validDeviceKeys.includes(missingKey));
    throw new Error(`device cannot have a key named '${firstInvalidKey}'`);
  }

  if (device.os) {
    validateOS(device.os);
  }

  if (device.platform) {
    validatePlatform(device.platform);
  }
};

export { validateDevice, validateOS, validatePlatform };
